import { useSearchParams } from "react-router-dom";
import { InCryptoBuy } from "./inCrypto";
import {ChangeOutCrypto} from './outCrypto';

export const PageCryptoTrading = () => {
  const [params] = useSearchParams();
  return params.get('type') === '2'? < ChangeOutCrypto /> : <InCryptoBuy />
};
